import { render, staticRenderFns } from "./details.follow.vue?vue&type=template&id=60251290&"
import script from "./details.follow.vue?vue&type=script&lang=js&"
export * from "./details.follow.vue?vue&type=script&lang=js&"
import style0 from "./details.follow.vue?vue&type=style&index=0&id=60251290&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports